import React from 'react';
import { useTheme } from '@mui/material';
import WidgetAlert, { WidgetErrorType } from 'components/widgetParts/WidgetAlert';
import { defaultSettings } from './RadialSentimentSettings';
import RadialSentimentChart from './RadialSentimentChart';
import { Query } from 'system/query/Query';
import { getSingleOriginalRequestByName, getSingleWidgetResponseByName } from 'system/widget/Widget';
import withQueryWidget, { WithQueryWidgetProps } from 'components/widgetParts/queryWidgetComposition/withQueryWidget';

function RadialSentimentContent(props: WithQueryWidgetProps) {
  const currentState = { ...defaultSettings, ...props.widget?.data?.settings };

  const apiResponseInfo = getSingleWidgetResponseByName(props.apiResponses, 'radial-sentiment');
  const originalRequest = getSingleOriginalRequestByName(props.activeWidgetRequests, 'radial-sentiment');
  const responseBody = apiResponseInfo?.responseBody || {};

  const response = responseBody?.sentiment?._buckets || [];

  const theme = useTheme();
  const namedColors: any = theme.colors.namedColors;
  const sentimentKeyToColor: Record<string, string> = {'p': 'positive', 'n': 'negative', '0': 'neutral'};

  // Parse the data into a format that the chart can use
  const arcData = response.map((row: any) => {
    const drilldownQuery = new Query({
      query: {
        op: "contains",
        fields: ["sentiment"],
        labels: [row._label],
        values: [row._key]
      }
    });

    return {
      name: row._label,
      key: row._key,
      value: row._count,
      percent: (row._percent * 100).toFixed(1),
      fill: namedColors[sentimentKeyToColor[row._key]],
      query: drilldownQuery
    };
  });

  return (
    <>
      {arcData.length !== 0 ? (
        <RadialSentimentChart
          settingsState={currentState}
          data={arcData}
          queryInfo={props.queryInfo}
          queryDisplayTitle={apiResponseInfo?.queryDisplayTitle}
          originalRequest={originalRequest}
          activeQueryIds={apiResponseInfo?.originatingRequest?.activeQueryIds}
          />
      ) : (
        <WidgetAlert type={WidgetErrorType.NO_DATA} />
      )};
    </>
  );
}

export default withQueryWidget(RadialSentimentContent, {
  hasSettingsDialog: true,
  hasQueryDialog: true
});